<template>
  <div class="container">
    <div style="height: 100vh" class="row d-flex align-items-center">
    <div class="col-lg-6 offset-lg-3">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <card class="card-login card-white">
            <div style="padding: 2rem 1rem;" class="col-12">
              <h2 class="card-title">XABCD EDUCATION CENTER</h2>
              <ValidationProvider
                name="email"
                rules="required"
                v-slot="{ passed, failed, errors }"
              >
              <base-input
                required
                v-model="email"
                type="text"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
                :error="errors[0]"
                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
             </ValidationProvider>

             <ValidationProvider
               name="password"
               rules="required|min:5"
               v-slot="{ passed, failed, errors }"
             >
             <base-input
               required
               v-model="password"
               placeholder="Password"
               addon-left-icon="tim-icons icon-lock-circle"
               type="password"
               :error="errors[0]"
               :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
             </base-input>
            </ValidationProvider>
            <p v-show="error" class="text-danger">Incorrect email or password.</p>
            <base-button native-type="submit" type="primary" class="mb-3" size="md">
              Login
            </base-button>
            <hr>
            <base-button tag="a" href="/registration" simple type="info" >Register</base-button>&nbsp;
            <base-button tag="a" href="/my-account/lost-password/" simple type="danger">Forgot Password</base-button>

            </div>


          </card>
        </form>
      </ValidationObserver>
    </div>
  </div>
  </div>
</template>
<script>
const axios = require('axios');
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("email", email);
extend("min", min);
extend("required", required);
export default {
  data() {
    return {
      email: "",
      password: "",
      subscribe: true,
      error: null,
    };
  },
  methods: {
    async submit() {
      try{
        console.log(process.env);
        this.error = null;
        const response = await axios.get(process.env.VUE_APP_URL+'/dashboard/login.php',{ params: {user_login: this.email, user_password: this.password} });
        if(response.data === true) window.location.href = '/dashboard';
        if(response.data !== true) this.error = true;
      }catch(err){
        console.log(err);
      }
    }
  }
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
